import api from './client';

export interface PreferenciaGrid {
  gridId: string;
  estadoJson: string;
  atualizadoEm?: string | null;
}

interface ApiResponse<T> {
  success: boolean;
  data: T;
  message?: string;
}

class PreferenciasGridApi {
  async obter(gridId: string): Promise<PreferenciaGrid | null> {
    const response = await api.get<ApiResponse<PreferenciaGrid | null>>(`/preferencias-grid/${gridId}`);
    return response.data.data;
  }

  async salvar(gridId: string, estadoJson: string): Promise<void> {
    await api.put<ApiResponse<unknown>>(`/preferencias-grid/${gridId}`, {
      gridId,
      estadoJson,
    });
  }
}

export const preferenciasGridApi = new PreferenciasGridApi();
